import { useTranslation } from "react-i18next";import React from 'react';
import { Card, CardContent } from '@/shared/components/ui/card';
import { cn } from '@/shared/utils';

export const ProcurementStatCard = ({
  title,
  value,
  icon: Icon,
  color = 'indigo',
  subtitle,
  trend,
  prefix = '',
  suffix = '',
  className
}) => {const { t } = useTranslation("procurement");
  const colorMap = {
    indigo: 'bg-indigo-500/10 text-indigo-600',
    navy: 'bg-blue-900/10 text-blue-900 dark:text-blue-300',
    blue: 'bg-blue-500/10 text-blue-600',
    green: 'bg-emerald-500/10 text-emerald-600',
    amber: 'bg-amber-500/10 text-amber-600',
    red: 'bg-red-500/10 text-red-600',
    purple: 'bg-purple-500/10 text-purple-600'
  };

  const borderColorMap = {
    indigo: 'border-l-indigo-500',
    navy: 'border-l-blue-900',
    blue: 'border-l-blue-500',
    green: 'border-l-emerald-500',
    amber: 'border-l-amber-500',
    red: 'border-l-red-500',
    purple: 'border-l-purple-500'
  };

  const formatValue = (val) => {
    if (typeof val === 'number') {
      return prefix + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + suffix;
    }
    return prefix + val + suffix;
  };

  return (
    <Card className={cn(
      "card-elevated border-l-4 transition-all duration-200 hover:shadow-lg",
      borderColorMap[color],
      className
    )}>
      <CardContent className="p-5">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
              {title}
            </p>
            <p className="text-2xl font-bold mt-2 text-foreground font-['Space_Grotesk']">
              {formatValue(value)}
            </p>
            {subtitle &&
            <p className="text-sm text-muted-foreground mt-1">
                {subtitle}
              </p>
            }
            {trend &&
            <p className={cn(
              "text-sm mt-1 font-medium flex items-center gap-1",
              trend.type === 'up' ? 'text-emerald-600' : trend.type === 'down' ? 'text-red-600' : 'text-muted-foreground'
            )}>
                <span>{trend.type === 'up' ? '↑' : trend.type === 'down' ? '↓' : '→'}</span>
                <span>{trend.value}%</span>
                {trend.label && <span className="text-muted-foreground font-normal">{t("vsLastPeriod", "vs last period")}</span>}
              </p>
            }
          </div>
          {Icon &&
          <div className={cn(
            "flex h-12 w-12 items-center justify-center rounded-xl",
            colorMap[color]
          )}>
              <Icon className="h-6 w-6" />
            </div>
          }
        </div>
      </CardContent>
    </Card>);

};